import React from "react";
import Svg, { Path } from "react-native-svg";

const CloseIcon = (props) => {
  const { fill = "#242424", fillOpacity = 1, height = 18, width = 18 } = props;

  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <Path
        d="M13.65 12l7.008-7.01a1.165 1.165 0 10-1.649-1.649l-7.01 7.01-7.008-7.01a1.165 1.165 0 10-1.649 1.65L10.351 12l-7.009 7.009a1.165 1.165 0 00.825 1.99c.298 0 .597-.114.824-.341L12 13.648l7.009 7.01a1.163 1.163 0 001.649 0 1.164 1.164 0 000-1.649L13.649 12z"
        fill={fill}
        fillOpacity={fillOpacity}
      />
    </Svg>
  );
};

export default CloseIcon;
